// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3L9m2","title":"ClientInsurance_title__2d6fe","itemText":"ClientInsurance_itemText__2XEVr"};